import type { TweenT } from "tweenly"
import {
    bounceIn,
    bounceOut,
    expandIn,
    expandOut,
    fadeIn,
    fadeOut,
    revealFromBottom,
    revealFromLeft,
    revealFromRight,
    revealFromTop,
    revealToBottom,
    revealToLeft,
    revealToRight,
    revealToTop,
    rotateXLeft,
    rotateXRight,
    rotateYLeft,
    rotateYRight,
    rotateZLeft,
    rotateZRight,
    scaleSubtleIn,
    scaleSubtleOut,
    slideFromBottom,
    slideFromLeft,
    slideFromRight,
    slideFromTop,
    slideToBottom,
    slideToLeft,
    slideToRight,
    slideToTop,
    zoomIn,
    zoomOut,
} from "../styles/tweens.styles"

export const AnimationTweens: TweenT[] = [
    fadeIn,
    fadeOut,
    zoomIn,
    zoomOut,
    scaleSubtleIn,
    scaleSubtleOut,
    rotateXRight,
    rotateXLeft,
    rotateYRight,
    rotateYLeft,
    rotateZRight,
    rotateZLeft,
    slideFromLeft,
    slideToLeft,
    slideFromRight,
    slideToRight,
    slideFromTop,
    slideToTop,
    slideFromBottom,
    slideToBottom,
    bounceIn,
    bounceOut,
    expandIn,
    expandOut,
    revealFromLeft,
    revealToLeft,
    revealFromRight,
    revealToRight,
    revealFromTop,
    revealToTop,
    revealFromBottom,
    revealToBottom,
]

export const VideoPanelTweens: TweenT[] = [
    fadeIn,
    fadeOut,
    zoomIn,
    zoomOut,
    slideFromLeft,
    slideToLeft,
    slideFromRight,
    slideToRight,
    slideFromTop,
    slideToTop,
    slideFromBottom,
    slideToBottom,
]

// export const dynamicAnimationTweens: TweenT[] = [slideFromLeft]
